import { RegistrationError } from '../components/registration-error'

export const RegistrationExpiredPage = () => (
  <RegistrationError
    titleKey='login.registration.expiredTitle'
    descriptionKey='login.registration.expiredDescription'
    pageTitleKey='login.registration.expiredTitle'
  />
)
